import React from "react";
import { Box, Grid, TextField, Button, Modal } from "@mui/material";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Slider from "@mui/material/Slider";
import { useAppDispatch } from "../store/hooks";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { H4, H5, Small } from "../components/Typography";
import { load } from "../constants/storage";
import { getFundSipList } from "../redux/actions/PortfolioAction";
import {
  amcItems,
  catItems,
  riskFilterItems,
  subCategoryFilterItems,
} from "../constants/constant";
import { toast } from "react-hot-toast";
import * as Models from "../models";

type MyModalProps = {
  item: any;
  handleClose: () => void;
  handleSave: (value: any) => void;
  data: any;
  allData: any;
  open: boolean;
};

function FilterScreenMobile({
  item,
  handleClose,
  handleSave,
  data,
  allData,
  open,
}: MyModalProps) {
  const dispatch = useAppDispatch();
  const [selectedCategory, setSelectedCategory] = React.useState<string>("");
  const [amcData, setAMCData] = React.useState<any>(amcItems);
  const [selectedAMC, setSelectedAMC] = React.useState<string>("");
  const [selectedRisk, setSelectedRisk] = React.useState<string>("ALL");
  const [sliderValue, setSlidervalue] = React.useState<any>("");
  const [selectedAMCCode, setSelectedAMCCode] = React.useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] =
    React.useState<string>("");
  const [finalData, setFinalData] = React.useState([]);

  const onhandleBlur = (event: any) => {
    const textData = event.target.value.toUpperCase();

    const newData = allData?.filter(function (item: any) {
      const leavetypeData = item?.amc_name
        ? item?.amc_name?.toUpperCase()
        : "".toUpperCase();
      return leavetypeData.indexOf(textData) > -1;
    });
    setAMCData(newData);
  };
  const marks = [
    {
      value: 100,
      label: "100",
    },
    {
      value: 500,
      label: "500",
    },
    {
      value: 1000,
      label: "1000",
    },
    // {
    //   value: 5000,
    //   label: "5000",
    // },
  ];

  const applyFilter = () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.FundSipRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      source: "web",
      amc_code: selectedAMCCode,
      asset_category: selectedCategory === "Index" ? "Equity" : "",
      asset_sub_category:
        selectedSubCategory === "ALL"
          ? ""
          : selectedSubCategory === "High Returns"
          ? "Small Cap"
          : selectedSubCategory === ""
          ? item?.asset_sub_category
          : selectedSubCategory,
      fund_type: "ALL",
      min_initial_investment: sliderValue === 0 ? "" : sliderValue,
      offset: 0,
      risk_profile: selectedRisk,
      title: selectedSubCategory === "" ? item.title : selectedSubCategory,
    };

    getFundSipListData(req);
  };
  const getFundSipListData = async (req: any) => {
    let token = load("token");

    dispatch(getFundSipList(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        const sortedData = response?.flexiData?.sort((a: any, b: any) =>
          (a?.vr_rating == "Not Rated" ? -1 : a?.vr_rating?.length) <
          (b?.vr_rating == "Not Rated" ? -1 : b?.vr_rating?.length)
            ? 1
            : -1
        );

        if (item?.isGoal) {
          let goalSortedList = sortedData?.filter(
            (a: any) => Number(item?.sipAmount) >= Number(a?.min_sip_amount)
          );
          let goalList = goalSortedList.map(function (ele: any) {
            return { ...ele, isGoal: item?.isGoal };
          });
          setFinalData(goalList);
          handleSave(goalList);
          return;
        }
        setFinalData(sortedData);
        handleSave(sortedData);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };
  const toggleSelectedAMC = (itemName: string, item: any) => {
    setSelectedAMC(itemName);
    setSelectedAMCCode(item.amc_code);
  };
  const valueLabelFormat = (value: number) => {
    const mark = marks.find((mark) => mark.value === value);
    return mark ? mark.label : "";
  };
  function valuetext(value: number) {
    setSlidervalue(value);
    return `${value}`;
  }
  const pressClear = () => {
    setSelectedAMC("");
    setSelectedAMCCode("");
    setSelectedCategory("");
    setSelectedRisk("ALL");
    setSelectedSubCategory("");
    setSlidervalue("");
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <>
        {item?.title == "Global" ||
        item?.title == "Sector Specific" ||
        item?.title == "Solution Oriented" ||
        item?.isGoal ||
        item?.title == "Thematic" ? null : (
          <Grid
            item
            sx={{
              boxShadow: 2,
              display: "flex",
              flexDirection: "column",
              width: "80%",
              height: "100vh",
              background: "#FFF",
              overflowY: "auto", // Enable vertical scrolling
            }}
          >
            <Box
              sx={{
                background: "#FFF3DB",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
                display: "flex",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                borderBottom: "0.5px solid #D2D2D2",
              }}
            >
              <H4
                fontWeight={"600"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  mb: 2,
                  mt: 2,
                  ml: 2,
                }}
              >
                Filters
              </H4>
              <Grid onClick={pressClear}>
                <H4
                  fontWeight={"600"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    mb: 2,
                    mt: 2,
                    mr: 2,
                    color: "#DD9401",
                  }}
                >
                  Clear all
                </H4>
              </Grid>
            </Box>
            <H5
              fontWeight={"500"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                background: "#F6F6F6",
                pt: 1,
                pb: 1,
                pl: 2,
              }}
            >
              AMC
            </H5>
            <Box
              sx={{
                background: "#fff",
                justifyContent: "center",
                // alignItems:'center',
                flexDirection: "column",
                display: "flex",
              }}
            >
              <TextField
                id="standard-bare"
                variant="outlined"
                placeholder="Search"
                onChange={onhandleBlur}
                // value={searchText}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      style={{
                        marginRight: -15,
                      }}
                    >
                      <SearchRoundedIcon
                        style={{
                          fontSize: "16px",
                          color: "#D3D3D3",
                        }}
                      />
                    </IconButton>
                  ),
                  style: {
                    height: "30px",
                    marginTop: 5,
                    width: "90%",
                    marginLeft: 10,
                    marginRight: 10,
                    marginBottom: 10,
                  },
                }}
              />

              <Box sx={scrollableContainerStyle}>
                {data.map((item: any, index: any) => (
                  <Box
                    sx={{
                      pt: 1.2,
                      pb: 1.2,
                      pr: 2,
                      pl: 1,
                      alignItems: "center",
                      display: "flex",
                      borderBottom: "0.5px solid #D2D2D2",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleSelectedAMC(item.amc_name, item)}
                  >
                    <DoneRoundedIcon
                      style={{
                        fontSize: "20px",
                        color:
                          selectedAMC === item.amc_name ? "#DD9401" : "#D3D3D3",
                      }}
                    />
                    <Small
                      sx={{
                        fontWeight: "500",
                        ml: 0.4,
                        width: "90%",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {item.amc_name}
                    </Small>
                  </Box>
                ))}
              </Box>
            </Box>

            <Accordion
              sx={{
                background: "#F6F6F6",
                boxShadow: 0,
                marginTop: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <H5
                  fontWeight={"500"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Category
                </H5>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  background: "#f00",
                  boxShadow: 0,
                  p: 0,
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    justifyContent: "center",
                    // alignItems:'center',
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  {catItems.map((item: any, index: any) => (
                    <Box
                      sx={{
                        pt: 1.2,
                        pb: 1.2,
                        pr: 2,
                        pl: 1,
                        alignItems: "center",
                        display: "flex",
                        borderBottom: "0.5px solid #D2D2D2",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedCategory(item.name)}
                    >
                      <DoneRoundedIcon
                        style={{
                          fontSize: "20px",
                          color:
                            selectedCategory === item.name
                              ? "#DD9401"
                              : "#D3D3D3",
                        }}
                      />
                      <Small
                        sx={{
                          fontWeight: "500",
                          ml: 0.4,
                          width: "90%",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {item.name}
                      </Small>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                background: "#F6F6F6",
                boxShadow: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <H5
                  fontWeight={"500"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Risk
                </H5>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  background: "#f00",
                  boxShadow: 0,
                  p: 0,
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    justifyContent: "center",
                    // alignItems:'center',
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  {riskFilterItems.map((item: any, index: any) => (
                    <Box
                      sx={{
                        pt: 1.2,
                        pb: 1.2,
                        pr: 2,
                        pl: 1,
                        alignItems: "center",
                        display: "flex",
                        borderBottom: "0.5px solid #D2D2D2",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedRisk(item.name)}
                    >
                      <DoneRoundedIcon
                        style={{
                          fontSize: "20px",
                          color:
                            selectedRisk === item.name ? "#DD9401" : "#D3D3D3",
                        }}
                      />
                      <Small
                        sx={{
                          fontWeight: "500",
                          ml: 0.4,

                          width: "90%",

                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {item.name}
                      </Small>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                background: "#F6F6F6",
                boxShadow: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <H5
                  fontWeight={"500"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Investment
                </H5>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  background: "#f00",
                  boxShadow: 0,
                  p: 0,
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    justifyContent: "center",
                    // alignItems:'center',
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  <Box sx={{ pl: 2, pr: 2 }}>
                    <H5
                      fontWeight={"500"}
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        pt: 2,
                        pb: 2,
                      }}
                    >
                      {sliderValue}
                    </H5>

                    <Slider
                      aria-labelledby="discrete-slider-values"
                      valueLabelDisplay="auto"
                      getAriaValueText={valuetext}
                      step={null}
                      marks={marks}
                      min={0}
                      max={1000}
                      valueLabelFormat={valueLabelFormat}
                    />
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                background: "#F6F6F6",
                boxShadow: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <H5
                  fontWeight={"500"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Sub Category
                </H5>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  background: "#f00",
                  boxShadow: 0,
                  p: 0,
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    justifyContent: "center",
                    // alignItems:'center',
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  {subCategoryFilterItems.map((item: any, index: any) => (
                    <Box
                      sx={{
                        pt: 1.2,
                        pb: 1.2,
                        pr: 2,
                        pl: 1,
                        alignItems: "center",
                        display: "flex",
                        borderBottom: "0.5px solid #D2D2D2",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedSubCategory(item.title)}
                    >
                      <DoneRoundedIcon
                        style={{
                          fontSize: "20px",
                          color:
                            selectedSubCategory === item.title
                              ? "#DD9401"
                              : "#D3D3D3",
                        }}
                      />
                      <Small
                        sx={{
                          fontWeight: "500",
                          ml: 0.4,

                          width: "90%",

                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {item.title}
                      </Small>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
            <Box
              sx={{
                background: "#fff",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                display: "flex",
              }}
            >
              <Button
                onClick={applyFilter}
                disableElevation
                disableRipple
                size="medium"
                sx={[sxStylebutton, { textTransform: "none" }]}
              >
                Apply
              </Button>
              <Button
                variant="contained"
                onClick={handleClose}
                sx={[cancel, { textTransform: "none" }]}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        )}
      </>
    </Modal>
  );
}
const scrollableContainerStyle = {
  height: "200px", // Set your desired height here
  overflow: "auto",
};
const sxStylebutton = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: "80%",
  mb: 1,
  mt: 3,
};
const cancel = {
  background: "#FFF5D1",
  color: "#000",
  width: "80%",
  mb: 1,
  mt: 1,
};
export default FilterScreenMobile;
